<template>
  <div class="calcFormsForm">
    <div v-if="loading">
      <v-progress-circular
        :size="20"
        color="primary"
        class="mr-2"
        indeterminate
      ></v-progress-circular>
      Loading...
    </div>
    <div v-else-if="pensionElementItem">
      <v-form ref="pensionElementForm" v-model="isFormValid" lazy-validation>
        <div>
          <v-text-field
            label="Element name"
            v-model="pensionElementItem.Name"
            :rules="[rules.required]"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            label="Order"
            v-model="pensionElementItem.OrderNo"
            :rules="[rules.numField]"
            :readonly="!showFormButtons"
            type="number"
            min="0"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-checkbox
            label="Contingent"
            v-model="pensionElementItem.Contingent"
            :readonly="!showFormButtons"
            class="mt-0 pt-0"
            dense
            outlined
          ></v-checkbox>
        </div>
        <div>
          <v-text-field
            label="Pension increase"
            v-model="pensionElementItem.IncreaseCalc"
            :rules="[rules.required]"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            label="Rounding order"
            v-model="pensionElementItem.RoundingOrder"
            :rules="[rules.numField]"
            :readonly="!showFormButtons"
            type="number"
            min="0"
            dense
            outlined
          ></v-text-field>
        </div>
      </v-form>
      <div v-if="showFormButtons" class="formFooter">
        <div class="btnContainer">
          <v-btn v-if="elementId" color="error" outlined @click="onDelete" class="mr-4">
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onCancel" class="mr-4"> Cancel </v-btn>
          <v-btn color="primary" depressed @click="onSave"> Save </v-btn>
        </div>
      </div>
    </div>
    <div v-else>
      <v-alert type="info" outlined dense>No info found for this element</v-alert>
    </div>
    <Dialog ref="confirmationDialog" v-model="dialog"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'PensionElementsForm',
  components: {
    Dialog,
  },
  props: {
    elementId: { type: Number },
    planId: { type: Number },
  },

  data() {
    return {
      loading: false,
      isFormValid: false,
      dialog: false,
      pensionElementItem: null,
      rules: {
        required: (value) => !!value || 'Required.',
        numField: (v) => v >= 0 || 'Required.',
      },
    };
  },

  computed: {
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    elementId: function () {
      if (this.elementId) this.getPensionElement(this.elementId);
      else this.createNewPensionElement();
    },
  },

  created: function () {
    if (this.elementId) this.getPensionElement(this.elementId);
    else this.createNewPensionElement();
  },

  methods: {
    createNewPensionElement() {
      this.pensionElementItem = {
        ElementId: 0,
        PlanId: this.planId,
        Name: '',
        OrderNo: 0,
        Contingent: false,
        IncreaseCalc: '',
        RoundingOrder: 0,
      };
    },

    onCancel() {
      if (this.elementId) this.getPensionElement(this.elementId);
      else this.createNewPensionElement();
    },

    onSave() {
      const isFormValid = this.$refs.pensionElementForm.validate();
      if (isFormValid) this.saveData();
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deletePensionElement();
      } catch (err) {
        console.log();
      }
    },

    async getPensionElement() {
      this.loading = true;
      this.pensionElementItem = null;
      try {
        let response = await this.$api.get(
          '/PensionElements/GetPensionElement?id=' + this.elementId
        );

        if (!response.data) {
          const msg = 'Unable to load pension element with id ' + this.elementId;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        var data = response.data;
        this.pensionElementItem = data;
      } catch (err) {
        this.$store.commit('setNotificationMessage', {
          type: 'error',
          text: 'Something going wrong.',
        });
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async saveData() {
      this.updatePensionElement();
    },

    async updatePensionElement() {
      try {
        let response = await this.$api.post(
          '/PensionElements/UpdatePensionElement',
          this.pensionElementItem
        );

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Penstion element was saved',
        });
        if (this.pensionElementItem.ElementId === 0) {
          this.$emit('reloadList', 'update', response.data.Value);
        } else {
          this.$emit('reloadList', 'update');
          this.getPensionElement();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async deletePensionElement() {
      try {
        await this.$api.delete('/PensionElements/DeletePensionElement?id=' + this.elementId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Element is deleted',
        });
        this.$emit('reloadList', 'delete');
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
